import { FC } from "react";
import { ApplicationView, useApplicationView } from "@hooks/useApplicationView";
import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { useWorkspacesList } from "@api/workspace.api";
import { AddWorkspaceItemsCommandsList } from "./AddCommandsList";
import { AccountsCommandsList } from "./AccountsCommandsList";
import { WorkspaceNavigationCommands } from "./NavigationCommands";
import { WorkspaceSettingsCommandsList } from "./WorkspaceSettingsCommandsList";
import { WorkspacesCommandsList } from "./WorkspacesCommandsList";
import { AccountSettingsCommandList } from "./AccountSettingsCommandList";
import { CommandsListProps } from "./lib";
import { WorkspaceCommandsList } from "./WorkspaceCommandsList";
import { OrganizationActionsCommands } from "./OrganizationActionsCommands";
import { OrganizationNavigationCommands } from "./OrganizationNavigationCommands";
import { StaffCommands } from "./StaffCommands";

export const AllCommandsList: FC<CommandsListProps> = (props) => {
    const workspacesQuery = useWorkspacesList();
    const hasMultipleWorkspaces = workspacesQuery.data?.length
        ? workspacesQuery.data.length > 1
        : false;
    const view = useApplicationView();
    const activeOrganization = useActiveOrganization();

    const workspacesGroupHeading = activeOrganization
        ? "Clients"
        : "Workspaces";

    const viewCommands = (() => {
        switch (view) {
            case ApplicationView.ORGANIZATION_VIEW:
                return (
                    <>
                        <OrganizationActionsCommands />
                        <OrganizationNavigationCommands />
                        <AccountSettingsCommandList />
                        {hasMultipleWorkspaces ? (
                            <WorkspacesCommandsList
                                groupHeading={workspacesGroupHeading}
                            />
                        ) : null}
                    </>
                );
            case ApplicationView.MAIN:
                return (
                    <>
                        <AddWorkspaceItemsCommandsList />
                        <AccountsCommandsList
                            includeStaticAccounts
                            {...props}
                        />
                        <WorkspaceNavigationCommands />
                        <AccountSettingsCommandList />
                        <WorkspaceCommandsList />
                        <WorkspaceSettingsCommandsList />
                        {hasMultipleWorkspaces ? (
                            <WorkspacesCommandsList
                                groupHeading={workspacesGroupHeading}
                            />
                        ) : null}
                    </>
                );
            case ApplicationView.PERSONAL_VIEW:
                return (
                    <>
                        <AccountSettingsCommandList />
                        {hasMultipleWorkspaces ? (
                            <WorkspacesCommandsList groupHeading="Workspaces" />
                        ) : null}
                    </>
                );
            case ApplicationView.ONBOARDING:
                return null;
            default: {
                view satisfies never;
                return null;
            }
        }
    })();

    return (
        <>
            {viewCommands}
            <StaffCommands />
        </>
    );
};
